import React from 'react';

type props = {
    name: string,
    isActive: boolean
}

export const TabCard = ({ name, isActive }: props) => {
    return (

        <li className={isActive ? 'green' : 'simple'} >{name || "Subject"}</li>


    )
}
